import TableChartIcon from "@mui/icons-material/TableChart";
import CustomQRInvoice from "./custom_qr_invoice";
export const inf_partner_qr_invoice = [
  {
    label: "Table",
    accessor: "data_businesspartners",
    sm: 30,
    dfl: "",
    type: "custom",
    data_select: [],
    name_select: "",
    section: "custom",
    sectionTitle: "Puntos de venta",
    change: false,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    customComponent: CustomQRInvoice,
    method: "ALL-CUSTOM",
    icon: TableChartIcon,
  },
];
